import React, {Component} from 'react'
import clip from './assets/videos/ninth_newpaper_plant.mp4';
import first from './assets/images/ninth_newpaper_plant1.jpg';
import second from './assets/images/ninth_newpaper_plant2.jpeg';
import third from './assets/images/ninth_newpaper_plant3.jpg';
import fourth from './assets/images/ninth_newpaper_plant4.png';
import fifth from './assets/images/ninth_newpaper_plant5.png';
import sixth from './assets/images/ninth_newpaper_plant6.png';
import Chocolat from 'chocolat';
import { Link, NavLink } from 'react-router-dom'
import About from "./assets/components/aboutsection";
import Footer from "./assets/components/footer";
import videoposter from './assets/images/videoposter.jpg';
import LazyLoad from "vanilla-lazyload";

function lightbox(){ 
document.addEventListener("DOMContentLoaded", function(event) {
        Chocolat(document.querySelectorAll('.chocolat-parent .chocolat-image'))
      })
}

lightbox();


class ninth_newpaper_plant extends Component {
  render() {
    return (
      <div>

        <h1 className="main-title"><Link to="/">Columbus</Link></h1>
        <div className="wrapper">

       <video autoPlay loop muted className="wrapper__video" data-src={clip} poster={videoposter}>
          <source src={clip} type="video/mp4">
          </source>
       </video>
       <div className="page-content">
         <div className="content-wrapper">

         <h1 className="page-heading">The Republic Newspaper Plant and Offices</h1>
         <p>Originally built for The Republic, a daily newspaper in Columbus; it nows serves 
         as a site for the Indiana University's Master of Architecture program.
         It won an an award from American Institute of Architects (AIA) in 1975.
         In 2012, this building was named a National Historic Landmark for its innovative architecture.
         </p>

       </div>
       <h3>1971, Myron Goldsmith</h3>
       <h3>333 2nd Street</h3>
       </div>

        </div>

        <div className="gallery">

          <div className="heading">
            <h1>Gallery</h1>
          </div>

              <div className="image-container">
                  <a className="chocolat-image" href={first} title="Photo from SOD (Skidmore, Owings & Merrill) - https://www.som.com/projects/the_republic__newspaper_plant__offices">
                      <img src={first} />
                  </a>
                  <a className="chocolat-image" href={second} title="Photos from SOD (Skidmore, Owings & Merrill) - https://www.som.com/projects/the_republic__newspaper_plant__offices">
                     <img src={second} />
                  </a>
                  <a className="chocolat-image" href={third} title="Photo from Pinterest - https://www.pinterest.co.uk/pin/355714070558730855/">
                     <img src={third} />
                  </a>
                  <a className="chocolat-image" href={fourth} title="Columbus Screenshot">
                     <img src={fourth} />
                  </a>
                  <a className="chocolat-image" href={fifth} title="Columbus Screenshot">
                     <img src={fifth} />
                  </a>
                  <a className="chocolat-image" href={sixth} title="Columbus Screenshot">
                     <img src={sixth} />
                  </a>
              </div>

        </div>

        <About />

          <Footer />
          </div>
    )
  }
}

export default ninth_newpaper_plant;
